'use client';

import type { JSX } from 'react';
import { KaraokeBlock, loadDefinitionAudioCached } from '@/components/karaoke';

interface IKaraokeDefinitionProps {
  slug: string;
  text: string;
  initialAudioUrl: string | null;
}

export function KaraokeDefinition({
  slug,
  text,
  initialAudioUrl,
}: IKaraokeDefinitionProps): JSX.Element {
  return (
    <KaraokeBlock
      dir="ltr"
      initialAudioUrl={initialAudioUrl}
      label="Listen to definition"
      loadAudio={() => loadDefinitionAudioCached(slug)}
      showInlineIcon={false}
      text={text}
      textClassName="block not-italic text-lg text-foreground dark:text-foreground leading-relaxed"
    />
  );
}
